// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from './../../config';
import { changeErrFlagState } from './errorpage';

import {
  deleteAllCookies,
  getCookie,
  setCookie,
} from '../../utils/commonFunctions';

// import { setUserInfo } from 'store/user';

const refreshQuery = fetchBaseQuery({
  baseUrl: config.baseUrl,
  method: 'GET',
  prepareHeaders: (headers) => {
    const token = getCookie('refresh')
      ? JSON.parse(getCookie('refresh'))
      : false;
    headers.set('ngrok-skip-browser-warning', '69420');
    headers.set('Access-Control-Allow-Origin', 'no-cors');
    if (token) {
      headers.set('refreshToken', token);
    }
    headers.set('platform', 'web');
    return headers;
  },
});
const baseQuery = fetchBaseQuery({
  baseUrl: config.baseUrl,
  prepareHeaders: (headers) => {
    // const token = getState();
    const token = getCookie('token') ? JSON.parse(getCookie('token')) : false;
    // If we have a token set in state, let's assume that we should be passing it.
    headers.set('ngrok-skip-browser-warning', '69420');

    headers.set('Access-Control-Allow-Origin', 'no-cors');
    if (token) {
      headers.set('authorization', `authorization ${token}`);
    }
    headers.set('platform', 'web');
    return headers;
  },
});
const baseQueryWithReauth = async (args, api, extraOptions) => {
  try {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
      const token = getCookie('refresh')
        ? JSON.parse(getCookie('refresh'))
        : false;

      if (token) {
        // try to get a new token
        const { data: refreshResult } = await refreshQuery(
          '/auth/refresh-token',
          api,
          extraOptions
        );
        if (
          refreshResult?.status === 'SUCCESS' &&
          refreshResult?.data &&
          refreshResult?.data?.accessToken &&
          refreshResult?.data?.refreshToken
        ) {
          // const user = refreshResult.data.user;
          setCookie('token', refreshResult.data.accessToken);
          setCookie('refresh', refreshResult.data.refreshToken);

          // store the new token
          // api.dispatch(setUserInfo(refreshResult.data.user));
          // retry original query with new token
          result = await baseQuery(args, api, extraOptions);
        }
      }
      deleteAllCookies();
      api.dispatch({ type: 'logout' });
      // window.location = '/sign-in';
    }
    if (result.error && result.error.status === 403) {
      console.error('You don not have permission to access', result.error);
      window.history.pushState('', '', '/');
    }
    if (result.error && result.error.originalStatus === 429) {
      api.dispatch(changeErrFlagState(true));
    }
    return result;
  } catch (error) {
    console.log('error', error);
  }
};
// initialize an empty api service that we'll inject endpoints into later as needed
export const createApiInstance = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
export default createApiInstance;
